export default __webpack_public_path__ + "static/media/img1.dbd1eb73.jpg";